<template>
  <div class="row">
    <div class="col-md-6">
      <card-list-info header="Employee Information" :items="employeeInfo"></card-list-info>
    </div>
  </div>
</template>

<script>
  import dateMixin from '@/mixins/date';
  import CardListInfo from '@/components/CardListInfo';

  export default {
    mixins: [dateMixin],
    components: {
      CardListInfo,
    },
    created() {
      this.$store.dispatch('employees/LOAD_DETAIL_DATA');
    },
    computed: {
      detailedInfo() {
        return this.$store.getters['employees/get_detail_data'];
      },
      detailedCompanyInfo() {
        return this.detailedInfo.company;
      },
      displayName() {
        return this.detailedInfo.name;
      },
      employeeInfo() {
        const infoList = [
          { key: 'name', label: 'Name', value: this.detailedInfo.name },
          { key: 'number', label: 'Number', value: this.detailedInfo.number },
          { key: 'dob', label: 'Date of Birth', value: this.formatDate(this.detailedInfo.dob) },
          {
            key: 'created_at',
            label: 'Created at',
            value: this.formatDateDistance(this.detailedInfo.created_at),
            title: this.formatDateTime(this.detailedInfo.created_at),
          },
        ];

        return infoList;
      },
    },
  };
</script>

<style scoped lang="sass">

</style>



// WEBPACK FOOTER //
// src/views/pages/employee/detail/Index.vue